import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "selector-container"
};
const _hoisted_2 = {
  class: "role-list-container"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "optional-role-name"
};
const _hoisted_5 = {
  style: {
    "font-weight": "normal",
    "font-size": "0.7rem"
  }
};
const _hoisted_6 = {
  class: "stage-info-container"
};
const _hoisted_7 = {
  class: "stage-image-container"
};
const _hoisted_8 = {
  class: "drama-info"
};
const _hoisted_9 = {
  class: "info-container"
};
const _hoisted_10 = {
  class: "stage-name"
};
const _hoisted_11 = {
  class: "main-info"
};
const _hoisted_12 = {
  key: 0,
  class: "letter-content"
};
const _hoisted_13 = {
  key: 1,
  class: "letter-content"
};
const _hoisted_14 = {
  key: 2,
  class: "submit-tips"
};
import { ref, computed } from 'vue';
import { ElImage } from 'element-plus';
import store from '@/store';
import { getDifficultyDegree, getPerformanceDesc } from "@/tools/utils"; // pre-declaration

export default {
  __name: 'RoleSelector',
  props: {
    data: {
      type: Object,
      required: true
    },
    ticketType: {
      type: Number,
      required: true
    },
    times: {
      type: [Number, null],
      default: null,
      required: false
    }
  },
  emits: ['selected-role'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // refs

    const selectedRole = ref(null); // computed

    const roleArray = computed(() => store.state.role_array ?? []); // functions

    const roleClick = item => {
      selectedRole.value = item;
    };

    const submitRole = () => {
      emits('selected-role', props.data.stage_id, props.ticketType, selectedRole.value.id);
    };

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleArray.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: _normalizeClass(["optional-roles-card", selectedRole.value && item.id === selectedRole.value.id ? 'selected-roles-card' : '']),
          onClick: $event => roleClick(item)
        }, [_createVNode(_unref(ElImage), {
          src: item.avatar,
          fit: "cover",
          draggable: "false"
        }, null, 8, ["src"]), _createElementVNode("text", _hoisted_4, [_createTextVNode(_toDisplayString(item.nickname) + " ", 1), _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)), _createElementVNode("span", _hoisted_5, " id: " + _toDisplayString(item.id), 1)])], 10, _hoisted_3);
      }), 128))]), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_unref(ElImage), {
        src: __props.data.stage_image ?? __props.data?.performance?.drama?.image_url,
        fit: "contain",
        draggable: false
      }, null, 8, ["src"]), _createElementVNode("text", _hoisted_8, " 「" + _toDisplayString(__props.data.performance?.drama?.name) + " / " + _toDisplayString(_unref(getDifficultyDegree)(__props.data.performance?.drama?.difficulty)) + "」 ", 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("text", _hoisted_10, [_createElementVNode("b", null, _toDisplayString(__props.data.stage_name), 1), _createElementVNode("span", _hoisted_11, "   [" + _toDisplayString(_unref(getPerformanceDesc)(__props.data.performance?.status)) + "] ", 1)]), _createElementVNode("span", null, " 链接者：" + _toDisplayString(__props.data.performance.anchor.name), 1), _createElementVNode("span", null, " 雾海舟子：" + _toDisplayString(__props.data.ferryman.nickname), 1), _createElementVNode("span", null, " 剧本难度：" + _toDisplayString((__props.data.performance?.drama?.difficulty / 10).toFixed(1)) + " / 10.0 (" + _toDisplayString(_unref(getDifficultyDegree)(__props.data.performance?.drama?.difficulty)) + ") ", 1), _createElementVNode("span", null, " 剧本标签：" + _toDisplayString(__props.data.performance?.drama?.tendency), 1), _createElementVNode("span", null, " 剧本年代：" + _toDisplayString(__props.data.performance?.drama.era), 1), _createElementVNode("span", null, " 主要地点：" + _toDisplayString(__props.data.performance?.drama.location), 1), _createElementVNode("span", null, " 演出时间：" + _toDisplayString(`${__props.data.performance?.start_date} ~ ${__props.data.performance?.end_date}`), 1), _createElementVNode("span", null, " 预期时长：" + _toDisplayString(__props.data.performance?.drama.construction_period), 1), __props.times !== null ? (_openBlock(), _createElementBlock("span", _hoisted_12, " 邀请函类别：" + _toDisplayString(__props.ticketType === 0 ? '演职员' : '观众席'), 1)) : _createCommentVNode("", true), __props.times !== null ? (_openBlock(), _createElementBlock("span", _hoisted_13, " 邀请函可用次数：" + _toDisplayString(__props.times === 0 ? '无限制' : __props.times), 1)) : _createCommentVNode("", true), _createVNode(_component_el_row, {
        style: {
          "width": "100%",
          "justify-content": "flex-end",
          "margin-top": "32px"
        }
      }, {
        default: _withCtx(() => [selectedRole.value && __props.times !== null ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          onClick: submitRole
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" 加入舞台 ", -1)]))]),
          _: 1
        })) : selectedRole.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          onClick: submitRole
        }, {
          default: _withCtx(() => [_createTextVNode(" 【" + _toDisplayString(__props.ticketType === 0 ? '演职员' : '观众席') + "】席位申请 ", 1)]),
          _: 1
        })) : (_openBlock(), _createElementBlock("text", _hoisted_14, " 选择一个角色以进行席位申请 "))]),
        _: 1
      })])])]);
    };
  }

};